import type { AnalyticsProcess } from './constants';
import type { AnalyticsProcessId } from './helpers/createAnalyticsProcessId';
import { createAnalyticsProcessId } from './helpers/createAnalyticsProcessId';

class DynatraceIntegration {
	private analyticsProcessId: AnalyticsProcessId | undefined;
	private userTag: string | undefined;

	startProcess = (analyticsProcess: AnalyticsProcess) => {
		this.analyticsProcessId = createAnalyticsProcessId(analyticsProcess);
	};

	endProcess = () => {
		this.analyticsProcessId = undefined;
	};

	identifyUser = (userId: string) => {
		this.userTag = userId;
		window.dtrum?.identifyUser?.(userId);
	};

	enterAction = (name: string): number | undefined =>
		window.dtrum?.enterAction?.(name);

	leaveAction = (actionId: number) => {
		window.dtrum?.leaveAction?.(actionId);
	};

	sendBizEvent = (type: string, attributes?: Record<string, unknown>) => {
		window.dtrum?.sendBizEvent?.(type, {
			...attributes,
			analyticsProcessId: this.analyticsProcessId,
			userTag: this.userTag,
		});
	};

	reportPageChange = (pageName: string, pageGroup?: string) => {
		window.dtrum?.setPage?.({ name: pageName, group: pageGroup });
	};
}

export const dynatraceIntegration = new DynatraceIntegration();
